<template>
	<div class="checkbox-group">
		<Checkbox
			:id="`${uid}_cb_all`"
			:labelText="'All'"
			:value="'check_all'"
			:modelValue="getAllChecked"
			@input="checkedAll"
			v-if="displayCheckAll"
		/>
		<Checkbox
			:disabled="item.disabled"
			:id="`${uid}_${index}_cb`"
			:key="`${uid}_${index}`"
			:labelText="item.label"
			:modelValue="checkedValues.includes(item.value) ? item.value : null"
			:value="item.value"
			@input="changeValue"
			v-for="(item, index) in items"
		/>
	</div>
</template>
<script>
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
export default {
	name: 'CheckboxGroup',
	components: { Checkbox },
	props: {
		items: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ''
		},
		displayCheckAll: {
			type: Boolean,
			default: false
		},
		checkedValues: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		results() {
			return this.checkedValues.join(',');
		},
		getAllChecked() {
			let filteredItems = this.items.filter(
				item => item.value !== undefined
			);
			let unchecked = filteredItems.some(
				item => !this.checkedValues.includes(item.value)
			);
			return unchecked ? '' : 'check_all';
		}
	},
	methods: {
		shouldBeChecked(val) {
			return this.checkedValues.includes(val);
		},
		changeValue(val, isChecked) {
			val = val.toString();
			let checks = [...this.checkedValues];
			checks = checks.map(String);

			let added, removed;
			if (isChecked) {
				checks.push(val);
				added = val;
			} else {
				checks.splice(checks.indexOf(val), 1);
				removed = val;
			}
			this.$emit('change', checks, added, removed);
		},
		checkedAll(val, isCheck) {
			let isChecked = val === 'check_all' && isCheck;
			let checks = [...this.checkedValues];

			for (const item of this.items) {
				const idx = checks.indexOf(item.value);

				if (isChecked) {
					if (idx === -1 && item.value !== undefined) {
						checks.push(item.value);
					}
				} else {
					if (idx > -1) {
						checks = checks.filter(c => c !== item.value);
					}
				}
			}
			this.$emit('change', checks);
		}
	}
};
</script>

<style lang="scss">
.checkbox-group {
	display: grid;
	gap: $gutter-lg $gutter-xl;
	grid-template-columns: repeat(2, 1fr);

	@include mq($from: sm-l) {
		grid-auto-flow: column;
		grid-template-columns: inherit;
	}
}

.fieldset--vertical {
	.checkbox-group {
		grid-auto-flow: initial;
		grid-template-columns: 1fr;
	}
}
</style>
